

export const Module3 = (props) => { 

  return ( 
    <>
    <div className="fetcher">
      <div className="header">
      <div className="headline">
        <i className="fas fa-cog"></i>Module 3
        </div>
        <div className="right"><i className="fa-solid fa-clock"></i>00:00:00</div>
      </div>
      <div className="body mod3">
      </div>
      <div className="footer">
        Status<div className="right">All processes running</div>
      </div>
    </div>
    </>
  ); 

} 

